import "./index.css";
import "./App.css";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";

import LoginPage from "./pages/LoginPage";
import HomePage from "./pages/HomePage";
import CreateaccountPage from "./pages/CreateaccountPage";
import AccountPage from "./pages/AccountPage";
import DevisPage from "./pages/DevisPage";
import ManageaccountPage from "./pages/ManageaccountPage";
import ReservationPage from "./pages/ReservationPage";
import PaiementPage from "./pages/PaiementPage";
import InformationPage from "./pages/InformationPage";
import PrixPage from "./pages/PrixPage";
import ConfirmationPage from "./pages/ConfirmationPage";

// ✅ Petit composant interne pour le scroll
function ScrollToTopInternal() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

export default function App() {
  return (
    <Router>
      <ScrollToTopInternal /> {/* ✅ ici */}

      <Routes>
        <Route path="/mesreservation" element={<ReservationPage />} />
        <Route path="/confirmation" element={<ConfirmationPage />} />
        <Route path="/tarifs" element={<PrixPage />} />
        <Route path="/information" element={<InformationPage />} />
        <Route path="/paiement" element={<PaiementPage />} />
        <Route path="/manageaccount" element={<ManageaccountPage />} />
        <Route path="/" element={<HomePage />} />
        <Route path="/devis" element={<DevisPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/createaccount" element={<CreateaccountPage />} />
        <Route path="/account" element={<AccountPage />} />
      </Routes>
    </Router>
  );
}
